// Dedup analytics page route (DEV-16231). Filters → time-series chart with
// dedup overlay → top workflows + top noisy keys, all backed by
// /v1/run-timeseries.
//
// The sidebar exposes a single "Orchestrator" entry; this route is reached
// via the Analytics tab at the top of every /orchestrator/* page.
import { createFileRoute } from '@tanstack/react-router';
import { type CSSProperties } from 'react';

import { AnalyticsPage } from '../../components/orchestrator/AnalyticsPage';
import { OrchestratorTabs } from '../../components/orchestrator/OrchestratorTabs';

const tabsSpacing: CSSProperties = { marginBottom: 'var(--sp-4)' };

function AnalyticsRoute() {
  return (
    <>
      <OrchestratorTabs containerStyle={tabsSpacing} />
      <AnalyticsPage />
    </>
  );
}

export const Route = createFileRoute('/orchestrator/analytics')({ component: AnalyticsRoute });
